import React from 'react';
import { AnnotationCategory } from '../types/annotation';

interface AnnotationPinProps {
  x: number;
  y: number;
  category: AnnotationCategory;
  index: number;
  selected?: boolean;
  onClick?: () => void;
  scale?: number;
}

const CATEGORY_COLORS: Record<AnnotationCategory, string> = {
  'Action': '#e74c3c',
  'Navigation': '#3498db',
  'State Change': '#f39c12',
  'Validation': '#9b59b6',
  'API Call': '#2ecc71',
  'Note': '#95a5a6',
};

const AnnotationPin: React.FC<AnnotationPinProps> = ({
  x,
  y,
  category,
  index,
  selected,
  onClick,
  scale = 1.35,
}) => {
  const color = CATEGORY_COLORS[category] || '#95a5a6';

  return (
    <g transform={`translate(${x}, ${y})`} onClick={onClick} style={{ cursor: 'pointer' }}>
      <g transform={`scale(${scale})`}>
        {/* Teardrop shape */}
        <path
          d="M0,-24 C-8,-24 -12,-18 -12,-12 C-12,-4 0,0 0,0 C0,0 12,-4 12,-12 C12,-18 8,-24 0,-24Z"
          fill={color}
          stroke={selected ? '#fff' : 'rgba(0,0,0,0.3)'}
          strokeWidth={selected ? 2.5 : 1.5}
          filter="drop-shadow(0 2px 3px rgba(0,0,0,0.3))"
        />
        {/* Index number */}
        <text
          y={-13}
          textAnchor="middle"
          fill="#fff"
          fontSize="10"
          fontWeight="bold"
          pointerEvents="none"
        >
          {index}
        </text>
      </g>
    </g>
  );
};

export default AnnotationPin;
